<app-bottom-sheet #sheet ariaLabel="تنظیمات پرتفوی" (closed)="onSheetClosed()">
	<ng-template #body>
		<div class="flex flex-col gap-3 pb-2" data-cy="portfolio-settings-content">
			<h3 class="flex items-center justify-center gap-1 text-sm font-bold text-gray-900">
				<ui-icon width="20" height="20" iconName="setting" aria-hidden="true" />
				تنظیمات پرتفوی
			</h3>

			<span class="text-sm font-bold text-gray-900" id="portfolio-price-basis-label">محاسبات قیمت بر اساس</span>

			<div class="-mx-4 flex flex-col" role="radiogroup" aria-labelledby="portfolio-price-basis-label">
				@for (option of priceBasisOptions; track option.value; let first = $first) {
					<div class="flex flex-col gap-1 px-4 pb-3">
						<!-- The design-system radio prints its label at `font-bold`; the
							handoff has these at medium. A plain `font-medium` on the host
							does not reach the label's own class, so the weight is applied to
							the span that carries it. -->
						<ui-radio-button
							class="[&_span]:font-medium"
							size="lg"
							structure="ltr"
							[name]="priceBasisRadioName"
							[label]="option.label"
							[value]="option.value"
							[checked]="isSelected(option.value)"
							[attr.data-cy]="'portfolio-price-basis-' + option.value"
							(valueChange)="onPriceBasisChange($event)" />

						@if (option.description) {
							<p class="px-6 text-justify text-3.25 text-gray-500">{{ option.description }}</p>
						}
					</div>
				}
			</div>

			@if (saveError(); as error) {
				<p class="text-xs text-orange-400" role="alert" data-cy="portfolio-settings-save-error">{{ error }}</p>
			}
		</div>
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full gap-2 pb-3" data-cy="portfolio-settings-actions">
			<ui-button
				type="button"
				class="min-w-0 flex-1"
				variant="green"
				size="lg"
				extraButtonClasses="w-full"
				label="ذخیره"
				data-cy="portfolio-settings-save"
				[disabled]="!canSave()"
				[loading]="saving()"
				(clicked)="onSaveClick()" />
			<ui-button
				type="button"
				class="min-w-0 flex-1"
				extraButtonClasses="w-full"
				variant="mute"
				size="lg"
				label="انصراف"
				data-cy="portfolio-settings-cancel"
				(clicked)="onCancelClick()" />
		</div>
	</ng-template>
</app-bottom-sheet>
